import { Navigate } from "react-router-dom";
import { systemConfigurationNavigation } from "./navigation/navigation-model";
import { useVisibleNavigationItems } from "./navigation/use-navigation";

export function SettingsIndexRedirect() {
  const items = useVisibleNavigationItems(systemConfigurationNavigation);
  const href = items.find((item) => item.href)?.href;
  return href ? <Navigate replace to={href} /> : null;
}
